import { useToast } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';

import { ApiError, getServices, checkServiceAccess } from './businessPortalApi';

export const useCheckServiceAccess = (authCheckUri: string) => {
    const serviceAccessQuery = useQuery({
        queryKey: ['authCheck'],
        queryFn: () => checkServiceAccess(authCheckUri),
    });

    return serviceAccessQuery;
};

export const useGetServices = (options: { enabled?: boolean }) => {
    const serviceQuery = useQuery({
        queryKey: ['services'],
        queryFn: getServices,
        enabled: options.enabled,
    });
    const toast = useToast();

    if (serviceQuery.isError) {
        const error = serviceQuery.error as ApiError;
        toast({
            title: 'Something went wrong while fetching services',
            description: error.message,
            position: 'top',
            status: 'error',
            duration: 4000,
            isClosable: true,
        });
    }

    return serviceQuery;
};
